import { IntegrationId } from 'integrations/common/streams/tabularMappings/types';
import { Column } from '@ardoq/table-legacy';
import { ExternalLink } from '@ardoq/link';
import {
  Connection,
  ServiceNowConnection,
} from '@ardoq/api-types/integrations';
import { type I18nLocale, t } from '@ardoq/i18n';

export const getIntegrationExtraColumns = (
  integrationId: IntegrationId,
  i18nLocale: I18nLocale
): Column<Connection>[] => {
  if (integrationId === 'servicenow-v3') {
    return [
      {
        dataIndex: 'baseUrl',
        title: t(
          i18nLocale,
          'integrations:connections.columns.baseUrl',
          'Base URL'
        ),
        valueRender: (_, row) => {
          const connection = row as ServiceNowConnection;
          return (
            <ExternalLink
              opensInNewTabLabel={t(
                i18nLocale,
                'common:labels.opensInNewTab',
                '(new tab)'
              )}
              href={connection.baseUrl}
            >
              {connection.baseUrl}
            </ExternalLink>
          );
        },
        headerStyle: { width: '35%' },
      },
    ];
  }

  return [];
};
